import DishItemNutrition from "./DishItemNutrition";

export default DishItemNutrition;
